"use client";

import Link from "next/link";
import { Store } from "lucide-react";
import HomeSectionContainer from "@/components/home/HomeSectionContainer";

export function SellerCTASection() {
  return (
    <section>
      <HomeSectionContainer className="!w-[calc(100%-2rem)] !max-w-[70rem] !px-0 md:!w-[calc(100%-3rem)] xl:!max-w-[70rem]">
        <div
          className="relative mx-auto max-w-4xl overflow-hidden rounded-2xl border border-[rgba(109,61,245,0.16)] bg-[#ece7f6] px-6 py-5 shadow-[0_8px_20px_-18px_rgba(76,29,149,0.28)] sm:px-10 sm:py-6"
          data-testid="seller-cta-card"
        >
          <div className="relative mx-auto max-w-2xl text-center">
            <div className="mx-auto mb-2 flex h-9 w-9 items-center justify-center rounded-full border border-[rgba(124,58,237,0.16)] bg-white/40 text-[#6d3df5]">
              <Store className="h-4 w-4" aria-hidden="true" />
            </div>
            <p className="text-[0.72rem] font-semibold uppercase tracking-[0.18em] text-[#6d3df5]">
              For sellers
            </p>
            <h2 className="mt-2 text-2xl font-semibold tracking-[-0.045em] text-[#111827] sm:text-3xl">
              Own a local business?
            </h2>
            <p className="mt-2 text-sm leading-6 text-[#62748e] sm:text-base">
              Start selling on YourBarrio and reach local customers through a marketplace built for neighborhood commerce.
            </p>
            <div className="mt-4">
              <Link
                href="/business"
                prefetch={false}
                className="inline-flex min-h-11 w-full items-center justify-center rounded-xl border border-[rgba(76,29,149,0.18)] bg-[#4c1d95] px-5 py-2.5 text-[15px] font-semibold !text-white shadow-[0_2px_6px_rgba(76,29,149,0.14)] transition duration-200 hover:bg-[#411991] hover:!text-white hover:shadow-[0_3px_8px_rgba(76,29,149,0.18)] focus-visible:!text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300/40 sm:w-auto"
              >
                Start selling on YourBarrio
              </Link>
            </div>
          </div>
        </div>
      </HomeSectionContainer>
    </section>
  );
}
